import React, { useState } from 'react';
import Draggable from 'react-draggable';
import { Trash2, Move, Settings, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DraggableElementProps {
  id: string;
  type: string;
  content: React.ReactNode;
  position: { x: number; y: number };
  onDelete: (id: string) => void;
  onSelect: (id: string) => void;
  onDuplicate: (id: string) => void;
  onPositionChange: (id: string, position: { x: number; y: number }) => void;
  isSelected: boolean;
}

export const DraggableElement: React.FC<DraggableElementProps> = ({
  id,
  type,
  content,
  position,
  onDelete,
  onSelect,
  onDuplicate,
  onPositionChange,
  isSelected,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDrag = (e: any, data: any) => {
    onPositionChange(id, { x: data.x, y: data.y });
  };

  return (
    <Draggable
      position={position}
      onDrag={handleDrag}
      onStart={() => setIsDragging(true)}
      onStop={() => setIsDragging(false)}
      handle=".drag-handle"
    >
      <div 
        className={`absolute ${isSelected ? 'outline outline-2 outline-primary' : ''}`}
        onClick={() => onSelect(id)}
      >
        {isSelected && (
          <div className="absolute -top-10 left-0 flex items-center gap-1 bg-white border rounded-md p-1 shadow-sm z-10">
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-6 w-6 drag-handle cursor-move"
            >
              <Move className="h-3 w-3" />
            </Button>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-6 w-6"
              onClick={() => onDuplicate(id)}
            >
              <Copy className="h-3 w-3" />
            </Button>
            <Button 
              variant="ghost" 
              size="icon" 
              className="h-6 w-6 text-destructive hover:text-destructive"
              onClick={() => onDelete(id)}
            >
              <Trash2 className="h-3 w-3" />
            </Button>
          </div>
        )}
        <div 
          className={`min-w-[50px] min-h-[30px] ${isDragging ? 'opacity-50' : ''}`}
          data-element-type={type}
          data-element-id={id}
        >
          {content}
        </div>
      </div>
    </Draggable>
  );
}; 